module.exports = __webpack_public_path__ + "img/pfcomticketmediode50a100reais.388c03c2.png";